<template>
<v-list-tile @click='$emit("selected", item)' >
  <v-list-tile-avatar >
    <v-tooltip right
      v-if='item.automatically_add_to_appointments' >
      <v-icon slot='activator' color='amber'>flash_on</v-icon>
      <span>{{ $t('info.auto_on') }}</span>
    </v-tooltip>
    <v-tooltip v-else right >
      <v-icon
        slot='activator'
        color='green'>trip_origin</v-icon>
        <span>{{ $t('info.auto_off') }}</span>
    </v-tooltip>
  </v-list-tile-avatar>
  <v-list-tile-content >
    <v-list-tile-title>
      <practitioner-faces
        v-if='item.practitioner'
        :size=20
        :practitioner-ids="[item.practitioner]"
        class='mr-2' />
      <strong>{{item.icd10}}. {{item.process}} @
      {{ formatCurrency(item.currency, item.price) }}</strong>
    </v-list-tile-title>
    <v-list-tile-sub-title >
      {{ luxonDateformat(item.start_date, 'ccc d MMM yyyy') }}
      <span v-if='item.stop_date' >
        - {{ luxonDateformat(item.stop_date, 'ccc d MMM yyyy') }}
      </span>
      <span v-else >until forever</span>
      <v-chip
        v-if='isCurrent'
        class="v-chip--x-small" color='amber' label >active</v-chip>
    </v-list-tile-sub-title >
      <v-list-tile-sub-title v-if='item.automatically_add_to_appointments' class='hidden-xs-only' >
          <v-icon small >info</v-icon>
          Will be automatically added to appointments created between these dates
      </v-list-tile-sub-title >
      <v-list-tile-sub-title v-else class='hidden-xs-only' >
          <v-icon small >info</v-icon>
          Will <strong>never</strong> be automatically added to appointments
      </v-list-tile-sub-title>
      <!-- <v-list-tile-sub-title class='hidden-xs-only' >
          <v-icon small >info</v-icon>
          Applies to new appointments created after {{dateformat(item.created_date, 'ddd DD MMM YYYY \\at HH:mm')}}
      </v-list-tile-sub-title> -->

  </v-list-tile-content>
  <slot name='action' v-if='withDelete' >
    <v-list-tile-action >
      <v-btn
        :disabled='!isOwner'
        @click.stop='$emit("selected", item)' icon ><v-icon>edit</v-icon></v-btn>
    </v-list-tile-action>
    <v-list-tile-action >
      <v-btn
        :disabled='!isOwner'
        @click.stop='dialogs.delete = true' icon ><v-icon>delete</v-icon></v-btn>
    </v-list-tile-action>

    <v-dialog v-model="dialogs.delete" width='290' >
      <v-card >
        <v-card-text >
          {{ $t('delete.confirm') }}
        </v-card-text>
        <v-card-actions >
          <v-btn
            @click="dialogs.delete = false" flat >
            {{ $t('buttons.cancel') }}
          </v-btn>
          <v-spacer ></v-spacer>
          <v-btn
            @click='$emit("clicked:delete", item);dialogs.delete = false' color='error' >
            {{ $t('buttons.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </slot>
</v-list-tile>
</template>

<script>
import {DateTime} from 'luxon'
import PractitionerFaces from '@/components/lists/PractitionerFaces.vue'

export default {
  name: 'TreatmentLogListItem',
  components: {
    PractitionerFaces
  },
  props: {
    item: { type: Object, default: () => { return {} } },
    withDelete: { type: Boolean, default: true }
  },
  data () {
    return {
      dialogs: {
        delete: false
      }
    }
  },
  computed: {
    isCurrent () {
      let now = DateTime.local()
      if (this.item.start_date) {
        let start = DateTime.fromISO(this.item.start_date)
        if (this.item.stop_date) {
          let stop = DateTime.fromISO(this.item.stop_date)
          return (now >= start && now <= stop)
          // return now.isSameOrAfter(start) && now.isSameOrBefore(stop)
        } else {
          return now >= start
        }
      }
      return false
    },
    isOwner () {
      if (this.item.practitioner === this.me.id) { return true }
      return false
    }
  },
  i18n: {
    messages: {
      en: {
        info: {
          auto_on: 'This code will automatically be added to new appointments for this client',
          auto_off: 'This code will NOT automatically be added to new appointments for this client'
        },
        delete: {
          confirm: 'Are you sure you want to remove this item from current treatment and diagnosis?'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TreatmentLogListItem.vue?4816ec28